<template>
  <div class="pa-7 mt-5">
    <!--タイトル-->
    <span class="subHead">
      {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2"
    large>
      {{ icon }}
    </v-icon>
    <!--作成方法(3つ)-->
    <v-row>
      <v-col cols="12" lg="4" xl="4"
      v-for="(method, i) in methods"
      :key="i">
      <v-card
      height="100%"
      class="pa-3"
      elevation="5">
       <v-layout
      justify-center
      class="my-2"
      id="case">
        Case {{ i+1 }}
      </v-layout>
        <v-layout justify-center>
          {{ method.branch }}
        </v-layout>
        <v-layout justify-center>
          <v-icon class="my-3">
            {{ methodIcon }}
          </v-icon>
        </v-layout>
        <v-layout justify-center>
          {{ method.content }}
        </v-layout>
      </v-card>
      </v-col>
    </v-row>
    <!--データテーブル-->
    <div class="mt-12">
      <v-layout
      justify-center
      class="mb-2"
      id="datatableTitle">
        {{ datatableTitle }}
      </v-layout>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th
              v-for="(item, i) in headers"
              :key="i"
              id="th">
              {{ item.header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in items"
            :key="i">
              <td>
                {{ item.title }}
              </td>
              <td>
                {{ item.static }}
              </td>
              <td>
                {{ item.service }}
              </td>
              <td>
                {{ item.cms }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<style>
#case {
  color: #880000;
  font-size: 19px;
  margin-top:2rem;
}
#datatableTitle {
  font-size: 22px;
}
#th {
  font-size: 14px;
}
</style>

<script>
export default {
  data () {
    return {
      title: 'ホームページ作成方法について',
      icon: 'mdi-cogs',
      methodIcon: 'mdi-chevron-triple-down',
      datatableTitle: '重視するポイントと各作成方法との相性',
      headers: [
        {
          header: '重視する項目'
        },
        {
          header: '静的ホームページ'
        },
        {
          header: 'ホームページサービス'
        },
        {
          header: 'CMS'
        }
      ],
      methods: [
        {
          branch: '記事の更新が少ない場合',
          content: 'ホームページ記述言語(HTML)を用いて作成'
        },
        {
          branch: '記事の更新は多いが、ランニングコストをかけたくない場合',
          content: 'ホームページ作成サービスを利用して作成'
        },
        {
          branch: '記事の更新が多く、レイアウトにもこだわりたい場合',
          content: 'オープンソースCMSを導入し、テンプレートを利用して作成'
        }
      ],
      items: [
        {
          title: '記事の更新',
          static: '×',
          service: '○',
          cms: '◎'
        },
        {
          title: 'レイアウトの自由度',
          static: '◎',
          service: '△',
          cms: '○'
        },
        {
          title: 'セキュリティ対策',
          static: '○',
          service: '◎',
          cms: '×'
        },
        {
          title: 'ランニングコスト',
          static: '○',
          service: '◎',
          cms: '×'
        }
      ]
    }
  }
}
</script>
